import Array from '.';
import { DEFAULT_EDITORS_FIT_DATA_ORDER } from "../../../../lib/utils/consts";

/** @type {UICore.Layout} */
const defaultArrayItem = {
  type: 'w-container',
  children: [{
    type: 'w-card',
    children: [{
      type: 'w-text',
      props: {
        text: '请双击这里，打开卡片进行设计'
      }
    }]
  }]
};

/** @type {UICore.ComponentMeta} */
const ArrayComponentMeta = {
  id: 'w-array',
  name: '卡片列表',
  visible: false,
  component: Array,
  isFormEditor: true,
  slots: [{
    id: 'item',
    type: 'scoped',
    default: {
      layout: defaultArrayItem
    }
  }, {
    id: 'empty',
    containerRef: 'emptySlot'
  }, {
    id: 'header',
    containerRef: 'headerSlot'
  }, {
    id: 'footer',
    containerRef: 'footerSlot'
  }],
  bindings: [{
    id: '数据源',
    pathProp: 'path',
    required: true,
    main: true,
    checkData: s => s.type === 'array'
  }, {
    id: '卡片的选中情况',
    prop: 'selectedIndex',
    event: 'changeSelect',
    checkData: s => s.type === 'array' || s.type === 'number' || s.type === 'integer',
    required: {
      $expr: 'props.selectable'
    }
  }],
  initialLayout: {
    extraStyle: {
      '.w-array-item.selectable': {
        '&.selected': {
          boxShadow: '0 10px 12px 0 rgba(0, 0, 0, 0.1), 0 0 8px 0 rgba(0, 0, 0, 0.2)'
        },
        '&:hover': {
          cursor: 'pointer'
        }
      }
    }
  },
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'path',
      type: 'string',
      title: '数据源'
    }, {
      id: 'readonly',
      type: 'boolean',
      title: '只读模式',
      default: false
    }, {
      id: 'selectable',
      type: 'boolean',
      title: '允许选中',
      default: false
    }, {
      id: 'selectedIndex',
      type: 'any',
      title: '选中项数据源',
      description: '单选模式下为 number，多选模式下是 index 数组',
      condition: 'props.selectable'
    }, {
      id: 'isSingleSelect',
      type: 'boolean',
      title: '单选',
      default: true,
      condition: 'props.selectable'
    }, {
      id: 'layoutMode',
      type: 'string',
      group: '排布内容',
      title: '布局方式',
      enum: [{
        label: '固定分列数',
        value: 'fixedColumnCount'
      }, {
        label: '固定列宽',
        value: 'fixedColumnWidth'
      }, {
        label: '逐行展示',
        value: 'lines'
      }, {
        label: '混排',
        value: 'inlineBlocks'
      }]
    }, {
      id: 'columnCount',
      type: 'integer',
      title: '分列数',
      default: 2,
      condition: 'props.layoutMode === "fixedColumnCount" || isExprObject(props.layoutMode)',
      group: '排布内容'
    }, {
      id: 'columnWidth',
      type: 'string',
      group: '排布内容',
      title: '每列宽度',
      condition: 'props.layoutMode === "fixedColumnWidth" || isExprObject(props.layoutMode)',
      description: '请填入固定值，例如：300px',
      default: '300px'
    }, {
      id: 'autoColumnCountStrategy',
      type: 'string',
      title: '计算分列数，除不尽时',
      condition: 'props.layoutMode === "fixedColumnWidth" || isExprObject(props.layoutMode)',
      group: '排布内容',
      enum: [{
        label: '适当加宽卡片',
        value: 'grow'
      }, {
        label: '左对齐内容',
        value: 'left'
      }, {
        label: '居中内容',
        value: 'center'
      }, {
        label: '右对齐内容',
        value: 'right'
      }, {
        label: '加宽卡片(尽量横向不留白)',
        value: 'auto-fit'
      }]
    }, {
      id: 'gap',
      type: 'string',
      group: '排布内容',
      title: '间距',
      description: '例如：16px 留空则使用默认值'
    }, {
      id: 'enableHeaderSlot',
      type: 'boolean',
      group: '功能',
      title: '在第一个卡片前，加点东西'
    }, {
      id: 'enableFooterSlot',
      type: 'boolean',
      group: '功能',
      title: '在最后一个卡片后，加点东西'
    }, {
      id: 'addButton',
      type: 'string',
      title: '添加按钮',
      group: '功能',
      enum: [{
        label: '不展示',
        value: 'hidden'
      }, {
        label: '普通按钮',
        value: 'default'
      }, {
        label: '很大的加号',
        value: 'plus-icon'
      }]
    }, {
      id: 'dragOrder',
      type: 'string',
      title: '拖拽顺序',
      group: '功能',
      enum: [{
        label: '不需要',
        value: 'none'
      }, {
        label: '在顶部',
        value: 'top'
      }, {
        label: '在左侧',
        value: 'left'
      }, {
        label: '整个卡片',
        value: 'whole'
      }]
    }, {
      id: 'dragAction',
      type: 'string',
      title: '拖拽顺序后',
      group: '功能',
      condition: 'props.dragOrder !== "none"',
      description: '可通过“行为”面板配置“拖拽顺序后”的行为',
      enum: [{
        label: '直接改数组',
        value: 'mutateArray'
      }, {
        label: '自定义',
        value: 'none'
      }]
    }, {
      id: 'deleteButton',
      type: 'string',
      title: '删除按钮',
      group: '功能',
      enum: [{
        label: '不需要',
        value: 'none'
      }, {
        label: '右上角',
        value: 'top-right'
      }, {
        label: '右下角',
        value: 'bottom-right'
      }]
    }, {
      id: 'hiddenItemWhenEmpty',
      type: 'boolean',
      group: '排布内容',
      title: '隐藏空内容的格子',
      default: false
    }, {
      id: 'keyingRule',
      title: '列表项的key',
      description: '相当于 v-for 里的 key 的计算方式',
      type: 'any',
      group: '高级配置',
      ui: {
        type: 'listKeyingRuleInput'
      }
    }, {
      id: 'addItemButtonText',
      title: '「添加」按钮的文案',
      type: 'string',
      group: '高级配置'
    }]
  },
  getLayoutName() {
    return '卡片列表';
  },
  getActions({
    instance
  }) {
    return [{
      title: '编辑“没有内容”状态',
      icon: 'fa fa-edit',
      highlighted: !!(instance !== null && instance !== void 0 && instance.emulateEmptyMode),
      execute() {
        // eslint-disable-next-line no-param-reassign
        instance.emulateEmptyMode = !instance.emulateEmptyMode;
      }
    }];
  },
  fitData({
    dataSchema,
    dataPath
  }) {
    if (dataSchema.type !== 'array') return null;
    return {
      type: 'editor',
      order: DEFAULT_EDITORS_FIT_DATA_ORDER,
      layout: {
        type: 'w-array',
        bindings: {
          数据源: dataPath
        }
      }
    };
  },
  stylePanel: ({
    instance
  }) => instance !== null && instance !== void 0 && instance.selectable ? {
    selectors: [{
      selector: '.w-array-item.selectable',
      name: '可选中容器',
      pseudoClasses: [{
        selector: '&.selected',
        name: '被选中'
      }]
    }]
  } : {},
  events: [{
    id: 'handleAdd',
    name: '添加一项时',
    asProp: 'handleAdd',
    desc: '$event 是默认添加的内容,你可以修改他,或者将希望添加的 item 返回为变量`res`',
    arguments: [{
      type: 'any',
      description: ' 默认添加的内容'
    }]
  }]
};
export default ArrayComponentMeta;